export default {
  "wt-checkbox": "_wt-checkbox_11isr6k_8",
  "wt-checkbox_size_m": "_wt-checkbox_size_m_11isr6k_17",
  "wt-checkbox_size_s": "_wt-checkbox_size_s_11isr6k_18",
  "wt-checkbox_size_xs": "_wt-checkbox_size_xs_11isr6k_24",
  "wt-checkbox__error-message_list": "_wt-checkbox__error-message_list_11isr6k_30",
  "wt-checkbox__error-message_single": "_wt-checkbox__error-message_single_11isr6k_34",
  "wt-checkbox__error-message": "_wt-checkbox__error-message_11isr6k_30",
  "wt-checkbox__input": "_wt-checkbox__input_11isr6k_42",
  "wt-checkbox__icon": "_wt-checkbox__icon_11isr6k_53",
  "wt-checkbox_indeterminate": "_wt-checkbox_indeterminate_11isr6k_81",
  "wt-checkbox_disabled": "_wt-checkbox_disabled_11isr6k_99",
  "wt-checkbox__checkmark": "_wt-checkbox__checkmark_11isr6k_126",
  "wt-checkbox_theme_light": "_wt-checkbox_theme_light_11isr6k_155",
  "wt-checkbox_error": "_wt-checkbox_error_11isr6k_188",
  "wt-checkbox_theme_dark": "_wt-checkbox_theme_dark_11isr6k_193"
};